import React, { useEffect, useState } from "react";
import ManageAccountTab from "../../ManageAccountTab";
import * as ProtectionPlanActions from "../../../../store/protectionPlanService/idf/actions";
import * as CSIDActions from "../../../../store/csid/actions";
import { useDispatch, useSelector } from "react-redux";
import IDFProtectionPlanDialogContainer from "./IDFProtectionPlanDialogContainer";
import { ApplicationState } from "../../../../store";
import ErrorBoundary from "../../../common/ErrorBoundary";
import { IPackage, IProduct } from "../../../../store/protectionPlanService/idf/types";
import IDFProtectionPlanGroup from "./IDFProtectionPlanGroup";
import { IPartnerConfig } from "../../../../store/configurationService/types";
import LogoContainer from "../../../common/LogoContainer";
import RenderIcons from "../../../../Assets/css/_icons/partner_icon/RenderIcons";

interface IProps {
    history: any;
}

const IDFProtectionPlan: React.FunctionComponent<IProps> = (props) => {
    const dispatch = useDispatch();
    const requestBillingInfo = (forceLoad: boolean) => dispatch(ProtectionPlanActions.actionCreators.requestBillingInfo(forceLoad));
    const requestProtectionPlan = (forcefullyRefresh: boolean) => dispatch(ProtectionPlanActions.actionCreators.requestProtectionPlan(forcefullyRefresh));
    const refreshCSIDUserStatus = () => dispatch(CSIDActions.actionCreators.getUserCSIDStatus(true));
    const partnerConfig: IPartnerConfig = useSelector(
        (state: ApplicationState) => (state.configurationState && state.configurationState?.configuration?.partnerConfig)!
    );
    const hasBillingProfile = useSelector((state: ApplicationState) => {
        let hasBillingInfo = false;
        let creditCardData = state?.billingInfoState?.billingInfoData?.creditCard;
        if ([creditCardData?.cardNumber, creditCardData?.nameOnCard].join("")) {
            hasBillingInfo = true;
        }
        return hasBillingInfo;
    });

    const protectionPlanSelector = useSelector((state: ApplicationState) => {
        return state.protectionPlanIdfState;
    });

    useEffect(() => {
        requestBillingInfo(false);
        requestProtectionPlan(false);
        if (isAvastId) {
            document.title = "Avast | Manage Profile | Protection Plan";
        }
    }, []);

    const [isFirstPlan, setIsFirstPlan] = useState(true);
    const [confirmationDialog, setConfirmationDialog] = useState(false);
    const [initialDialog, setInitialDialog] = useState("");
    const [packageIndex, setPackageIndex] = useState(-1);
    const isAvastId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2611
                ? true
                : false
            : false
    );

    const confirmChange = (index: number, initDialog: string) => {
        setPackageIndex(index);
        setInitialDialog(initDialog);
        setConfirmationDialog(true);
    };

    const closeProtectionPlanDialog = () => {
        setPackageIndex(-1);
        setInitialDialog("");
        refreshCSIDUserStatus();
        setConfirmationDialog(false);
    };

    const showNextPlan = () => {
        var protectionPlanTable: any = document.getElementById("protection-table");
        if (protectionPlanTable != null) {
            let currentPlan: number = 0;
            let currentPlanText = protectionPlanTable.getAttribute("class") + "";
            currentPlan = parseInt(currentPlanText.substr(currentPlanText.length - 1));
            let tablePlans: number = protectionPlanTable.rows[0].cells.length;
            tablePlans = tablePlans - 1;

            if (tablePlans === currentPlan) {
                (document.getElementById("btn-next-plan") as HTMLButtonElement)!.disabled = true;
            } else {
                protectionPlanTable.classList.remove("show-plan-" + currentPlan);
                currentPlan++;
                protectionPlanTable.classList.add("show-plan-" + currentPlan);

                if (tablePlans === currentPlan) {
                    (document.getElementById("btn-next-plan") as HTMLButtonElement)!.disabled = true;
                    (document.getElementById("btn-prev-plan") as HTMLButtonElement)!.disabled = false;
                } else {
                    (document.getElementById("btn-next-plan") as HTMLButtonElement)!.disabled = false;
                    (document.getElementById("btn-prev-plan") as HTMLButtonElement)!.disabled = false;
                }
            }
            setIsFirstPlan(false);
        }
    };

    const showPrevPlan = () => {
        let protectionPlanTable: any = document.getElementById("protection-table");
        if (protectionPlanTable != null) {
            let currentPlan: number = 0;
            let currentPlanText = protectionPlanTable.getAttribute("class") + "";
            currentPlan = parseInt(currentPlanText.substr(currentPlanText.length - 1));
            let tablePlans: number = protectionPlanTable.rows[0].cells.length;
            tablePlans = tablePlans - 1;

            if (currentPlan === 1) {
                (document.getElementById("btn-prev-plan") as HTMLButtonElement)!.disabled = true;
            } else {
                protectionPlanTable.classList.remove("show-plan-" + currentPlan);
                currentPlan--;
                protectionPlanTable.classList.add("show-plan-" + currentPlan);

                if (currentPlan === 1) {
                    (document.getElementById("btn-next-plan") as HTMLButtonElement)!.disabled = false;
                    (document.getElementById("btn-prev-plan") as HTMLButtonElement)!.disabled = true;
                } else {
                    (document.getElementById("btn-next-plan") as HTMLButtonElement)!.disabled = false;
                    (document.getElementById("btn-prev-plan") as HTMLButtonElement)!.disabled = false;
                }
            }
        }
    };

    const showRow = (section: string) => {
        const packageList = protectionPlanSelector.protectionPlanData.packageList;
        let providedArr = [];
        let showPrice = false;
        let showButton = false;

        if (packageList) {
            packageList.map((pkg) => {
                if (Number(pkg.Price) !== 0 &&  Number(pkg.isUserPaid) !== 0) {
                    showPrice = true;
                }
                if ((pkg.DisplayCancelButton && hasBillingProfile) || !pkg.IsActive) {
                    showButton = true;
                }
                if (pkg.providedBy) {
                    providedArr.push(pkg.providedBy);
                }
            });
        }

        switch (section) {
            case "price":
                if (showPrice) {
                    return true;
                }
                break;
            case "cta":
                if (showButton) {
                    return true;
                }
                break;
            case "providedBy":
                if (providedArr.length > 0) {
                    return true;
                }
                break;
            default:
                return false;
        }
    };

    const renderSpacer = () => {
        return (
            <th className="row-label" scope="col">
                <div className="sr-only">Feature</div>
            </th>
        );
    };

    const renderPackageHeaderRow = (section: string) => {
        return (
            <React.Fragment>
                {protectionPlanSelector.protectionPlanData &&
                    protectionPlanSelector.protectionPlanData.packageList &&
                    protectionPlanSelector.protectionPlanData.packageList.map((pkg, pkgIndex: number) => (
                        <th className="row-cell" scope="col" key={"pkg-detail-" + pkgIndex}>
                            <div className="plan-container">
                                {section === "title" ? (
                                    renderTitle(pkg)
                                ) : section === "price" ? (
                                    renderPrice(pkg)
                                ) : section === "cta" ? (
                                    renderButton(pkg, pkgIndex)
                                ) : section === "providedBy" ? (
                                    renderProvidedBy(pkg)
                                ) : (
                                    <></>
                                )}
                            </div>
                        </th>
                    ))}
            </React.Fragment>
        );
    };

    const renderTitle = (pkg: IPackage) => {
        return (
            <div className="plan-title">
                {pkg.name} {pkg.IsActive ? <span className="plan-current">Current</span> : null}
            </div>
        );
    };

    const renderPrice = (pkg: IPackage) => {
        if (Number(pkg.Price) !== 0) {
            return <React.Fragment>{displayPackagePrice(pkg)}</React.Fragment>;
        }
    };

    const displayPackagePrice = (pkg: IPackage) => {
        return (
            <React.Fragment>
                <div className="plan-price">
                    ${Number(pkg.Price).toFixed(2)}
                    {displaySubscriptionTypeAbbr(pkg)}
                </div>
            </React.Fragment>
        );
    };

    const displaySubscriptionTypeAbbr = (pkg: IPackage) => {
        return (
            <small>
                /{pkg["billing-cycle"]?.toLowerCase() === "monthly" && <abbr title="Monthly">mo</abbr>}
                {pkg["billing-cycle"]?.toLowerCase() === "yearly" && <abbr title="Yearly">yr</abbr>}
            </small>
        );
    };

    const renderButton = (pkg: IPackage, pkgIndex: number) => {
        if (pkg.DisplayCancelButton && hasBillingProfile) {
            /* CANCEL */
            return (
                <React.Fragment>
                    <div className="plan-cta">
                        <button
                            type="button"
                            className="btn-default btn-grey btn-min-width"
                            onClick={() => {
                                confirmChange(pkgIndex, "ProtectionPlanUpgradeConfirmation");
                                window.addToDataLayer({ event: "Protection Plan - " + pkg.ActionButtonText?.toUpperCase() });
                            }}
                        >
                            <span className="btn-text">
                                Cancel <span className="sr-only">{pkg.name}</span>
                            </span>
                        </button>
                    </div>
                </React.Fragment>
            );
        } else if (!pkg.IsActive) {
            /* UPGRADE */
            return (
                <React.Fragment>
                    <div className="plan-cta">
                        <button
                            type="button"
                            className="btn-default btn-primary btn-min-width"
                            onClick={() => {
                                confirmChange(pkgIndex, "ProtectionPlanUpgradeConfirmation");
                                window.addToDataLayer({ event: "Protection Plan - " + pkg.ActionButtonText?.toUpperCase() });
                            }}
                        >
                            <span className="btn-text">
                                {pkg.ActionButtonText} <span className="sr-only">to {pkg.name} Plan</span>
                            </span>
                        </button>
                    </div>
                </React.Fragment>
            );
        }
    };

    const renderProvidedBy = (pkg: IPackage) => {
        if (pkg.providedBy) {
            return (
                <React.Fragment>
                    <p>Provided by</p>
                    <strong>{pkg.providedBy}</strong>
                </React.Fragment>
            );
        }
    };

    const displayNoActiveProtectionPlan = () => {
        return (
            <div className="box">
                <div className="box-header col-xs-12 col-sm-12" style={{ backgroundColor: "#F4F4F4" }}>
                    <div className="content-sub-title text-align-center">
                        <div className="monitoring-alert-icon" style={{ fontSize: "40px" }}>
                            <em className="las la-exclamation-circle "></em>
                        </div>
                    </div>
                </div>
                <div className="box-content text-align-center">
                    <div className="msg-generic">You currently have no active protection plan.</div>
                    <div className="msg-generic">Please contact us if you have any questions or need more information</div>
                    <div className="msg-generic">
                        with regard to your account at <a href={'tel:"' + partnerConfig?.phoneNumber + '"'}>{partnerConfig?.phoneNumber}</a>
                        <div className="space-divider margin-top-l" />
                    </div>
                </div>
            </div>
        );
    };

    const displaySubscriptionCancelledMessage = () => {
        return (
            <React.Fragment>
                <div className="msg-generic msg-small margin-top-xs">
                    <RenderIcons iconName="info-circle" />
                    <p>
                        This account will be canceled on&nbsp;
                        <strong>{protectionPlanSelector?.protectionPlanData?.cancellationStatus?.cancellationDate}</strong>, the end of your current billing, as you
                        requested. If you change your mind before the cancellation takes effect, please call Member Services at &nbsp;
                        <a href={'tel:"' + partnerConfig?.phoneNumber + '"'}>{partnerConfig?.phoneNumber}</a>.
                    </p>
                </div>
                <div className="space-divider margin-top-xs" />
            </React.Fragment>
        );
    };

    const cancellationMessaage = () => {
        const cancellationStatus = protectionPlanSelector?.protectionPlanData?.cancellationStatus;
        if (cancellationStatus != null && cancellationStatus.requestedDate != null) {
            if (cancellationStatus.processedDate) {
                return displayNoActiveProtectionPlan();
            } else {
                return displaySubscriptionCancelledMessage();
            }
        }
    };

    return (
        <React.Fragment>
            <div className=" row">
                <div className="col-xs-12 row">
                    <h1 className="title-page" id="idf-protection-plan-page" tabIndex={-1}>
                        {isAvastId ? "Manage Profile" : "Manage Account"}
                    </h1>
                    <LogoContainer internalPage={true} />
                </div>
            </div>

            <ManageAccountTab selectedTab="2" isAvastId={isAvastId} />

            <div className="row" id="protection-plan-content">
                <div className="col-xs">
                    <div className="box offset-padding">
                        <div className="box-header">
                            <div className="box-title-container">
                                <div className="box-title-icon" aria-hidden="true">
                                    <RenderIcons iconName="cube" />
                                </div>
                                <div className="box-title-text">
                                    <h2 className="box-title">Protection Plan</h2>
                                </div>
                            </div>

                            {!protectionPlanSelector.isLoading && <React.Fragment>{cancellationMessaage()}</React.Fragment>}
                        </div>
                        {protectionPlanSelector == null || protectionPlanSelector.isLoading ? (
                            <div className="box loading"></div>
                        ) : (
                            <React.Fragment>
                                {protectionPlanSelector?.protectionPlanData?.packageList && protectionPlanSelector?.protectionPlanData?.packageList?.length > 0 && (
                                    <div className="box-content">
                                        <div id="plan-table-container" className="table-container scroll">
                                            {protectionPlanSelector?.protectionPlanData?.packageList?.length! > 1 && (
                                                <React.Fragment>
                                                    <div id="table-nav-left">
                                                        <button
                                                            type="button"
                                                            className="btn-default btn-icon-only"
                                                            title="Previous Plan"
                                                            id="btn-prev-plan"
                                                            disabled={isFirstPlan}
                                                            onClick={() => showPrevPlan()}
                                                        >
                                                            <span className="btn-icon">
                                                                <em className="las la-arrow-left"></em>
                                                            </span>
                                                            <span className="btn-text">Previous Plan</span>
                                                        </button>
                                                    </div>
                                                    <div id="table-nav-right">
                                                        <button
                                                            type="button"
                                                            className="btn-default btn-icon-only"
                                                            title="Next Plan"
                                                            id="btn-next-plan"
                                                            onClick={() => showNextPlan()}
                                                        >
                                                            <span className="btn-icon">
                                                                <em className="las la-arrow-right"></em>
                                                            </span>
                                                            <span className="btn-text">Next Plan</span>
                                                        </button>
                                                    </div>
                                                </React.Fragment>
                                            )}
                                            <table id="protection-table" className="show-plan-1">
                                                <caption className="sr-only">This table contains your selected plan and available plans</caption>
                                                <thead>
                                                    <React.Fragment>
                                                        <tr>
                                                            {renderSpacer()}
                                                            {renderPackageHeaderRow("title")}
                                                        </tr>
                                                        {showRow("price") && (
                                                            <tr>
                                                                {renderSpacer()}
                                                                {renderPackageHeaderRow("price")}
                                                            </tr>
                                                        )}
                                                        {showRow("cta") && (
                                                            <tr>
                                                                {renderSpacer()}
                                                                {renderPackageHeaderRow("cta")}
                                                            </tr>
                                                        )}
                                                        {showRow("providedBy") && (
                                                            <tr>
                                                                {renderSpacer()}
                                                                {renderPackageHeaderRow("providedBy")}
                                                            </tr>
                                                        )}
                                                    </React.Fragment>
                                                </thead>
                                                <tbody>
                                                    {protectionPlanSelector.protectionPlanData &&
                                                        protectionPlanSelector.protectionPlanData.productList?.map((product: IProduct, productIndex: number) => (
                                                            <IDFProtectionPlanGroup
                                                                key={"product-comp-" + productIndex}
                                                                index={productIndex}
                                                                packageList={protectionPlanSelector.protectionPlanData.packageList}
                                                                product={product}
                                                            />
                                                        ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                )}
                            </React.Fragment>
                        )}
                    </div>
                </div>
            </div>

            <ErrorBoundary componentName="Protection Plan Dialog Container" type="showError" replaceDefaultContent={false} errorMsg="">
                {confirmationDialog && (
                    <IDFProtectionPlanDialogContainer
                        initialDialog={initialDialog}
                        packageIndex={packageIndex}
                        onClose={closeProtectionPlanDialog}
                        history={props.history}
                    />
                )}
            </ErrorBoundary>
        </React.Fragment>
    );
};

export default IDFProtectionPlan;
